import { render } from "./App.vue?vue&type=template&id=3003675a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3003675a&lang=css"

import exportComponent from "/Users/peilijun/Desktop/AgCloudWeb2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__